import { UserProfile } from '../user/types';

const USER_STORAGE_KEY = 'userData';

export const saveToLocalStorage = (key: string, data: any): void => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    console.error('Error saving to localStorage:', error);
  }
};

export const getFromLocalStorage = <T>(key: string): T | null => {
  try {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error('Error reading from localStorage:', error);
    return null;
  }
};

export const saveUserProfile = (profile: UserProfile): void => {
  saveToLocalStorage(USER_STORAGE_KEY, profile);
};

export const getUserProfile = (): UserProfile | null => {
  return getFromLocalStorage<UserProfile>(USER_STORAGE_KEY);
};

export const clearUserProfile = (): void => {
  localStorage.removeItem(USER_STORAGE_KEY);
};

export const clearAllStorage = async (): Promise<void> => {
  try {
    // Nettoyer localStorage
    localStorage.clear();
    
    // Nettoyer sessionStorage
    sessionStorage.clear();
    
    // Nettoyer les cookies
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const [name] = cookie.split('=');
      if (name) {
        const trimmedName = name.trim();
        document.cookie = `${trimmedName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${window.location.hostname}`;
        document.cookie = `${trimmedName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
      }
    }

    // Attendre un court instant pour s'assurer que tout est nettoyé
    await new Promise(resolve => setTimeout(resolve, 100));
  } catch (error) {
    console.error('Error clearing storage:', error);
    throw new Error('Une erreur est survenue lors du nettoyage du stockage');
  }
};